import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserService } from './user.service';
import { flatMap, map, catchError, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DigestService } from './digest.service';

@Injectable({ providedIn: 'root' })
export class UnsubscribeGuard implements CanActivate {
    
    constructor(public snackBar: MatSnackBar, 
                public router: Router,
                private digestService: DigestService, 
                private userService: UserService) {}

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        if (route.queryParams.userId) {
            return this.digestService.unsubscribe(route.queryParams.userId)
            .pipe(
                flatMap(() => this.userService.isLoggedIn()),
                map(res => !!res.user),
                tap(isLoggedIn => isLoggedIn ? this.snackBar.open('You have been unsubscribed.', 'OK', { duration: 3000}): undefined),
                map(isLoggedIn => isLoggedIn ? this.router.createUrlTree(['/settings/schedule']) : true),
                catchError(() => {
                    this.snackBar.open('Unable to unsubscribe for unknown user.', 'OK', { duration: 3000});
                    return of(this.router.createUrlTree(['/login']));
                })
            );
        } else {
            this.snackBar.open('Unable to unsubscribe for unknown user.', 'OK', { duration: 3000});
            return this.router.createUrlTree(['/login']);
        } 
    }
}